import { Component } from "solid-js";

interface QuickCommerceIconProps {
  class?: string;
}

export const QuickCommerceIcon: Component<QuickCommerceIconProps> = (props) => {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class={props.class}
    >
      <path
        d="M10.0025 4V6.53395C9.96929 6.93754 10.2657 7.29326 10.6687 7.33333H15.998C16.4009 7.29326 16.6974 6.93754 16.6641 6.53395V4"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.3333 28H7.99992C6.52716 28 5.33325 26.8061 5.33325 25.3333V6.66667C5.33325 5.19391 6.52716 4 7.99992 4H18.6666C20.1393 4 21.3333 5.19391 21.3333 6.66667V12"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.6667 18.6667H13.3334"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 22.6667H13.3333"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.3333 17.3333H19.0106L20.3453 24H27.0719L27.9999 19.3333H19.4106"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M26.4374 27.2198C26.4633 27.2459 26.4631 27.288 26.4371 27.3139C26.411 27.3399 26.3689 27.3398 26.3429 27.3138C26.3169 27.2878 26.3169 27.2457 26.3428 27.2197C26.3688 27.1936 26.4109 27.1935 26.437 27.2194L26.4374 27.2198"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.0665 27.2198C21.0924 27.2459 21.0923 27.288 21.0662 27.3139C21.0402 27.3399 20.9981 27.3398 20.9721 27.3138C20.9461 27.2878 20.946 27.2457 20.972 27.2197C20.9979 27.1936 21.04 27.1935 21.0662 27.2194L21.0665 27.2198"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
